<div *ngIf="isLoading" id="load" class="loader"></div>
<div [class.isLoading]="isLoading">
    <h2 mat-dialog-title>
        <div *ngIf="currentStepIndex === 1">
            Select Trainings
        </div>
        <div *ngIf="currentStepIndex === 2">
            Assign Mentor
        </div>
        <div *ngIf="currentStepIndex === 3">
            Initiate Confirmation
        </div>
        <div *ngIf="currentStepIndex === 4">
            Confirmation
        </div>
        <button class="close-button" (click)="onCancel()" disableRipple>
            <span class="material-symbols-outlined">
                close
            </span>
        </button>
    </h2>

    <mat-dialog-content
        class="mat-typography initiate-custom-dialog"
    >
        <div class="step-container" [@slideInOut]="getAnimationState()">
            <div *ngIf="currentStepIndex === 1">
                <div
                    class="search-bar Custom-Search mx-auto mb-3"
                    style="height: 5%; margin: 40px; width: 100%;"
                >
                    <div class="input-seacrh">
                        <button type="submit" class="msicon">
                            <span class="material-symbols-outlined">search</span>
                        </button>
                        <input
                            type="search"
                            class="elastic-search"
                            [(ngModel)]="searchText"
                            placeholder="Search By Program"
                            (keyup)="searchAllPrograms()"
                        >
                    </div>
                    <!-- <div class="tools-required" style="flex-direction: row;">
                        <input
                            type="text"
                            [(ngModel)]="toolsRequired"
                            placeholder="Tools Required"
                        >
                    </div> -->
                    <div class="date-range">
                        <mat-form-field style="width: 45%;height: 70px;">
                            <input
                                matInput
                                [matDatepicker]="picker1"
                                placeholder="Start Date"
                                [(ngModel)]="fromDate"
                                readonly
                                [matDatepickerFilter]="validateStartDate"
                            >
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker aria-placeholder="Start Date" #picker1></mat-datepicker>
                        </mat-form-field>
                          
                        <mat-form-field class="toDatePicker">
                            <input
                                matInput
                                [matDatepicker]="picker2"
                                placeholder="End Date"
                                [(ngModel)]="toDate"
                                [matDatepickerFilter]="validateEndDate"
                                readonly
                            >
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker aria-placeholder="End Date" #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
        
                <div  class="row grid-data tab-background" >
                    
                    <div class="col-md-4 col-sm-6 pl-0"  *ngFor="let card of programList; index as i">
                       
                        <div class="card">
                            <div class="card-image">
                                <mat-checkbox
                                    class="check-box"
                                    [(ngModel)]="card.isChecked"
                                    (ngModelChange)="changeCheckedStatus(card, $event)"
                                ></mat-checkbox>
                                <img
                                    [src]="'../../../../assets/images/employeeCareer/code.jpg'"
                                >
                                <div class="text-overlay">
                                    <span class="inprogress" *ngIf="card.status == 'InProgress'">
                                        In Progress
                                    </span>
                                    <span class="completed" *ngIf="card.status == 'Completed'">
                                        Completed
                                    </span>
                                    <span class="notstarted" *ngIf="card.status == 'Not Started'">
                                        Not Started
                                    </span>
                                </div>
                            </div>
                            <div class="card-content">
                                <div class="department">
                                <span class="department-name">
                                    {{card.departmentPathName || card.subGroup}}
                                </span>
                                </div>
                                <p
                                    class="card-title"
                                    title="{{card.programName}}"
                                    matTooltip="{{card.programName}}"
                                >
                                    {{ card.programID + '-' + card.programName }}
                                </p>
                                <hr>
                                <div class="d-flex counts">
                                <div class="col-6">
                                    <i class="fa fa-line-chart"></i>
                                    <span class="pl-2">{{card?.complexityLevel}}</span><br>
                                    <i class="fa fa-caret-square-o-right"></i>
                                    <span class="pl-2">{{card?.totalCourses}} Courses</span>
                                </div>
                                <vr class="vertical"></vr>
                                <div class="col-6">
                                    <i class="fa fa-clock-o"></i>
                                    <span class="pl-2">{{card?.totalTopicsLength}} total hours</span><br>
                                    <i class="fa fa-list-alt"></i>
                                    <span class="pl-2">{{card?.totalTopics}} Topics</span>
                                </div>
                                </div>
                            </div>
                        </div>
                         
                        <ng-container *ngIf="(i + 1) % 4 == 0 || i == programList.length - 1">
                        <div class="row"></div>
                        </ng-container>
                     
                    </div>
                    <span
                        class="NoPrograms"
                        *ngIf="programList && !programList.length"
                    >No Programs Found</span>
                </div>
            </div>

            <div *ngIf="currentStepIndex === 2" class="step-content">
                <div class="mentor-confirm">
                    <div class="mentor-label">
                        Do you need to assign mentors? <sup class="error">*</sup>
                    </div>
                    <mat-radio-group
                        aria-labelledby="example-radio-group-label"
                        class="example-radio-group"
                        [(ngModel)]="yesOrNo"
                    >
                        <mat-radio-button
                            class="example-radio-button"
                            value="Yes"
                        >Yes</mat-radio-button>
                        <mat-radio-button
                            class="example-radio-button"
                            value="No"
                        >No</mat-radio-button>
                    </mat-radio-group>
                </div>
                <form class="select-mentor" [formGroup]="formData" [ngClass]="{ 'select-mentor-disabled': yesOrNo === 'No'}">
                    <div class="comments-label">
                        Select Mentors <sup class="error">*</sup>
                    </div>
                    <div class="multiSelect-textbox">
                        <app-typeahead-textbox
                            [allValues]="mentorDetails"
                            [values]="mentorDetailsValues"
                            [disable]="false"
                            (emittedValues)="getProspectContributorValues($event)"
                            [isApi]="true"
                            (searchText)="searchContributor($event)"
                            [placehold]="message"
                        ></app-typeahead-textbox>
                    </div>
                    <div
                        *ngIf="mentorListFetchError"
                        class="error-message"
                        style="color: red; margin-top: 10px;"
                    >
                        No mentors available for this competency. Please proceed without mentor or contact admin.
                    </div>
                </form>
            </div>

            <div *ngIf="currentStepIndex === 3" class="step-content">
                <div class="info-block">
                    <span>The following employees are already assigned to this training.</span>
                    <span>You can choose to <strong>Reassign</strong> the training if it has been completed, or <strong>Remove</strong> the employee from the assignment list.</span>
                </div>
            
                <div class="table">
                    <mat-table [dataSource]="trainingStatusTableData" matSort class="fixed-table">
                        <ng-container matColumnDef="employeeId">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Employee Id </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{ row.employeeId }} </mat-cell>
                        </ng-container>
                
                        <ng-container matColumnDef="firstName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> First Name </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{ getFirstName(row) }}</mat-cell>
                        </ng-container>
                
                        <ng-container matColumnDef="lastName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Last Name </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{ getLastName(row) }} </mat-cell>
                        </ng-container>
                
                        <ng-container matColumnDef="training">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Training </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{ row.sessionName }} </mat-cell>
                        </ng-container>
                
                        <!-- <ng-container matColumnDef="assignedStatus">
                          <mat-header-cell *matHeaderCellDef mat-sort-header> Assigned Status </mat-header-cell>
                          <mat-cell *matCellDef="let row"> Assigned </mat-cell>
                        </ng-container> -->
                
                        <ng-container matColumnDef="trainingStatus">
                            <mat-header-cell *matHeaderCellDef mat-sort-header>
                                Current Progress
                            </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{ row.trainingStatus }} </mat-cell>
                        </ng-container>
                
                        <ng-container matColumnDef="action">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                <a
                                    *ngIf="row.trainingStatus === 'Completed'|| row.trainingStatus === 'Delayed'"
                                    class="action-link"
                                    (click)="removeTraining(row, 'reassign')"
                                >Reassign</a>
                                <a class="action-link" (click)="removeTraining(row, 'remove')">Remove</a>
                          </mat-cell>
                        </ng-container>
                
                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
                        <mat-row
                            [class.odd]="i % 2 == 1"
                            [class.even]="i % 2 == 0"
                            *matRowDef="let row; columns: displayedColumns; let i = index;"
                        >
                        </mat-row>
                      </mat-table>
                </div>
            </div>
          
            <div *ngIf="currentStepIndex === 4" class="step-content">
                <div class="header">
                    Are you sure you want to assign the training?
                </div>
                <div class="training-details-container">
                    <div class="details-card">
                        <div class="deatils-header">
                            Training Details:
                        </div>
                        <div class="detail-row">
                            <div class="detail-item">
                                <span class="label">Program Name:</span>
                                <span class="value" id="programName">{{APIparams.programName}}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label">Mentor Name:</span>
                                <span class="value" id="trainingId">{{ APIparams.MentorNames }}</span>
                            </div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-item">
                                <span class="label">Start Date:</span>
                                <span class="value" id="startDate">
                                    {{APIparams.startDate | date:'mediumDate'}}
                                </span>
                            </div>
                            <div class="detail-item">
                                <span class="label">End Date:</span>
                                <span class="value" id="endDate">
                                    {{APIparams.endDate | date:'mediumDate'}}
                                </span>
                            </div>
                        </div>
                        <div class="detail-row">
                            <div class="detail-item">
                                <span class="label">Competency Name:</span>
                                <span class="value" id="trainingId">{{ APIparams.competencyName }}</span>
                            </div>
                            <div class="detail-item">
                                <span class="label">Participants Count:</span>
                                <span class="value" id="participantsCount">
                                    {{ APIparams.participants.length }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    
    </mat-dialog-content>
    
    <mat-dialog-actions class="review">
        <div *ngIf="currentStepIndex === 1">
            <button class="btn btn-outline btn-spacing" (click)="moveToPrevious('close')">
              Back
            </button>
            <button
                (click)="moveToNextScreen()"
                [disabled]="!fromDate || !toDate || !selectedCard"
                [class.disabled]="!fromDate || !toDate || !selectedCard"
                class="btn btn-primary"
            >
              Next
            </button>
        </div>
        <div *ngIf="currentStepIndex === 2">
            <button class="btn btn-outline btn-spacing" (click)="moveToPrevious()">
                Back
            </button>
            <button
                (click)="moveToNextScreen()"
                class="btn btn-primary"
                [disabled]="yesOrNo === 'Yes' && !mentorDetailsValues.length"
                [class.disabled]="yesOrNo === 'Yes' && !mentorDetailsValues.length"
            >
                Next
            </button>
        </div>
        <div *ngIf="currentStepIndex === 3">
            <button class="btn btn-outline btn-spacing" (click)="moveToPrevious()">
                Back
            </button>
            <button
                (click)="moveToNextScreen()"
                class="btn btn-primary"
                [disabled]="trainingStatusTableData.data.length > 0"
                [class.disabled]="trainingStatusTableData.data.length > 0"
            >
                Next
            </button>
        </div>

        <div *ngIf="currentStepIndex === 4">
            <button class="btn btn-outline btn-spacing" (click)="moveToPrevious()">
                Back
            </button>
            <button (click)="assignTraining()" class="btn btn-primary">
                Proceed
            </button>
        </div>
    </mat-dialog-actions>
</div>